import { TEXT } from "./texts";

const VIEW_FOLDER_AND_DOCUMENTS = [
  {
    id: 0,
    label: TEXT.ASSOCIATED_DOCUMENTS,
  },
  {
    id: 1,
    label: TEXT.DOCUMENT_FOLDERS,
  },
];

const VIEW_TYPE = {
  ASSOCIATED_DOCUMENTS: 0,
  DOCUMENT_FOLDERS: 1,
};

const EMAIL_THREAD_FORMAT = [
  {
    id: 9,
    label: TEXT.OUTLOOK_MESSAGE,
  },
  {
    id: 1,
    label: TEXT.MS_WORD_MESSAGE,
  },
];

const EMAIL_FILE_TYPE = {
  OUTLOOK_MESSAGE: 9,
  MS_WORD_MESSAGE: 1,
};

export { VIEW_FOLDER_AND_DOCUMENTS, VIEW_TYPE, EMAIL_THREAD_FORMAT, EMAIL_FILE_TYPE };
